(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["category-showcase"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initCategorySlider(slider) {
      if (slider.dataset.categorySliderReady) return;
      slider.dataset.categorySliderReady = 'true';

      var track = slider.querySelector('[data-category-track]');
      var prev = slider.querySelector('[data-category-prev]');
      var next = slider.querySelector('[data-category-next]');
      if (!track || !prev || !next) return;

      function update() {
        var overflowing = track.scrollWidth > track.clientWidth + 2;
        prev.hidden = !overflowing;
        next.hidden = !overflowing;
        prev.disabled = track.scrollLeft <= 2;
        next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
      }

      function scrollByPage(direction) {
        track.scrollBy({ left: direction * track.clientWidth * 0.8, behavior: 'smooth' });
      }

      prev.addEventListener('click', function () { scrollByPage(-1); });
      next.addEventListener('click', function () { scrollByPage(1); });
      track.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);
      update();
    }

    function initAll(scope) {
      (scope || document).querySelectorAll('[data-category-slider]').forEach(initCategorySlider);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { initAll(); });
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', function (event) {
      initAll(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-products"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initProductSlider(slider) {
      if (slider.dataset.ready) return;
      slider.dataset.ready = 'true';

      var track = slider.querySelector('[data-product-track]');
      var prev = slider.querySelector('[data-product-prev]');
      var next = slider.querySelector('[data-product-next]');
      if (!track || !prev || !next) return;

      function update() {
        var overflowing = track.scrollWidth > track.clientWidth + 2;
        prev.hidden = !overflowing;
        next.hidden = !overflowing;
        prev.disabled = track.scrollLeft <= 2;
        next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
      }

      function scrollByPage(direction) {
        track.scrollBy({ left: direction * track.clientWidth, behavior: 'smooth' });
      }

      prev.addEventListener('click', function () { scrollByPage(-1); });
      next.addEventListener('click', function () { scrollByPage(1); });
      track.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);
      update();
    }

    function initAll(scope) {
      (scope || document).querySelectorAll('[data-product-slider]').forEach(initProductSlider);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { initAll(); });
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', function (event) {
      initAll(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonials"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initTestimonialsSlider(slider) {
      if (slider.dataset.testimonialsReady) return;
      slider.dataset.testimonialsReady = 'true';

      var track = slider.querySelector('[data-testimonials-track]');
      var prev = slider.querySelector('[data-testimonials-prev]');
      var next = slider.querySelector('[data-testimonials-next]');
      if (!track || !prev || !next) return;

      function update() {
        var overflowing = track.scrollWidth > track.clientWidth + 2;
        prev.hidden = !overflowing;
        next.hidden = !overflowing;
        prev.disabled = track.scrollLeft <= 2;
        next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
      }

      prev.addEventListener('click', function () {
        track.scrollBy({ left: -track.clientWidth * 0.8, behavior: 'smooth' });
      });
      next.addEventListener('click', function () {
        track.scrollBy({ left: track.clientWidth * 0.8, behavior: 'smooth' });
      });
      track.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);
      update();
    }

    function initAll(scope) {
      (scope || document).querySelectorAll('[data-testimonials-slider]').forEach(initTestimonialsSlider);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { initAll(); });
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', function (event) {
      initAll(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
